import axios from 'axios';

// 获取当前环境的API地址
const getBaseURL = () => {
  // 判断是开发环境还是生产环境
  if (import.meta.env.DEV) {
    // 开发环境 - 使用本地代理
    return 'http://localhost:5000/api';
  } else {
    // 生产环境 - 使用相对路径
    return '/api';
  }
};

// 创建axios实例
const api = axios.create({
  baseURL: getBaseURL(),
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['x-auth-token'] = token; // 使用正确的标头名称
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未授权，清除token并跳转到登录页
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          break;
        case 502:
          console.error('服务器错误，请检查后端服务是否正常运行');
          break;
        default:
          console.error('请求错误:', error.response.data);
      }
    } else {
      console.error('网络错误或服务器未响应');
    }
    return Promise.reject(error);
  }
);

export default api; 
